"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Minimize = function Minimize(props) {
  return _react2["default"].createElement("svg", (0, _extends3["default"])({
    width: 12,
    height: 2,
    viewBox: "0 -4 12 2"
  }, props), _react2["default"].createElement("title", null, "FB61C913-B728-4091-A0A8-4DE5F5085300"), _react2["default"].createElement("rect", {
    x: 24,
    y: 10.5,
    width: 12,
    height: 1.5,
    rx: 0.75,
    transform: "translate(-24 -10)",
    className: "fill"
  }));
};

exports["default"] = Minimize;